<template>
  <UiModal
    :model-value="showDialog"
    title="Требуется авторизация"
    :max-width="400"
    persistent
    @update:model-value="onModelUpdate"
  >
    <p class="auth-prompt__text">Для добавления товаров в избранное необходимо войти в систему.</p>
    <UiAlert type="info" class="auth-prompt__alert">
      После входа ваши избранные товары будут сохранены
    </UiAlert>
    <template #footer>
      <UiButton variant="secondary" @click="closeDialog">Отмена</UiButton>
      <UiButton to="/login" @click="goToLogin">Войти</UiButton>
    </template>
  </UiModal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useFavoritesAuthPrompt } from '@/modules/profile/public'
import UiAlert from '@/shared/ui/UiAlert.vue'
import UiButton from '@/shared/ui/UiButton.vue'
import UiModal from '@/shared/ui/UiModal.vue'

interface Props {
  modelValue?: boolean
}

const props = withDefaults(defineProps<Props>(), { modelValue: false })

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  login: []
  close: []
}>()

const router = useRouter()
const favoritesAuthPrompt = useFavoritesAuthPrompt()

const showDialog = computed({
  get: () => props.modelValue || favoritesAuthPrompt.showAuthPrompt.value,
  set: (value: boolean) => {
    emit('update:modelValue', value)
    if (!value) favoritesAuthPrompt.closeAuthPrompt()
  },
})

function onModelUpdate(value: boolean) {
  showDialog.value = value
}

function goToLogin() {
  closeDialog()
  emit('login')
  router.push('/login')
}

function closeDialog() {
  emit('update:modelValue', false)
  favoritesAuthPrompt.closeAuthPrompt()
  emit('close')
}
</script>

<style scoped>
.auth-prompt__text {
  margin: 0 0 12px;
}

.auth-prompt__alert {
  margin: 0;
}
</style>
